import { parseAdditionalHeaders } from "../chatWidget/utils";

type ExecutionPayload = {
    baseUrl: string;
    flowId: string;
    message: string;
    input_type: string;
    output_type: string;
    sessionId?: string;
    output_component?: string;
    tweaks?: Object;
    api_key?: string;
    additional_headers?: { [key: string]: string } | string;
    signal?: AbortSignal;
};

export async function startExecution(payload: ExecutionPayload): Promise<Response> {
    const {
        baseUrl,
        flowId,
        message,
        input_type,
        output_type,
        sessionId,
        output_component,
        tweaks,
        api_key,
        additional_headers,
        signal
    } = payload;

    const data: any = { input_type, input_value: message, output_type };
    if (tweaks) data["tweaks"] = tweaks;
    if (output_component) data["output_component"] = output_component;
    if (sessionId) data["session_id"] = sessionId;
    
    const headers: { [key: string]: string } = {
        "Content-Type": "application/json",
        "Accept": "text/event-stream"
    };
    if (api_key) headers["x-api-key"] = api_key;
    
    if (additional_headers) {
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }
    
    return fetch(`${baseUrl}/api/v1/run/${flowId}/stream`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
        signal
    });
}

export async function resumeExecution(
    baseUrl: string,
    executionId: string,
    lastEventId: number,
    api_key?: string,
    additional_headers?: { [key: string]: string } | string
): Promise<Response> {
    const headers: { [key: string]: string } = {
        "Accept": "text/event-stream"
    };
    if (api_key) headers["x-api-key"] = api_key;
    if (lastEventId > 0) headers["Last-Event-ID"] = String(lastEventId);
    
    if (additional_headers) {
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }

    return fetch(`${baseUrl}/api/v1/executions/${executionId}/stream`, {
        method: "GET",
        headers: headers
    });
}

export async function cancelExecution(
    baseUrl: string,
    executionId: string,
    api_key?: string,
    additional_headers?: { [key: string]: string } | string
): Promise<Response> {
    const headers: { [key: string]: string } = {};
    if (api_key) headers["x-api-key"] = api_key;
    
    if (additional_headers) {
        const parsedHeaders = parseAdditionalHeaders(additional_headers);
        if (parsedHeaders) {
            Object.keys(parsedHeaders).forEach(key => {
                headers[key] = String(parsedHeaders[key]);
            });
        }
    }

    return fetch(`${baseUrl}/api/v1/executions/${executionId}/cancel`, {
        method: "POST",
        headers: headers
    });
}
